<div class="stat-box">
  <div class="header">
    <h1 class="mat-display-small">Casual Games</h1>
    <p class="">
      FantaZ Games and Tournaments can be competitively played for both cash and
      prizes!
    </p>
  </div>
  <mat-card appearance="outlined" class="content">
    <div class="item">
      <span class="step mat-headline-medium">1</span>
      <p class="">
        Compete for cash with players from down the street or around the world!
      </p>
      <span class="separator"></span>
    </div>
    <div class="item">
      <span class="step mat-headline-medium">2</span>
      <p class="">
        Casual game types include logic, strategy, hand-eye coordination, and
        more.
      </p>
      <span class="separator"></span>
    </div>
    <div class="item">
      <span class="step mat-headline-medium">3</span>
      <p class="">
        Once a tournament is complete, the player with the highest score wins.
      </p>
    </div>
  </mat-card>
</div>
